import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import api, { formatApiErrorDetail } from '../services/api';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!email) {
      setError('Por favor ingresa tu correo electrónico');
      return;
    }

    setLoading(true);
    try {
      await api.post('/api/v1/email/request-password-reset', { email });
      setSuccess(true);
    } catch (error) {
      console.error('Error requesting password reset:', error);
      setError(formatApiErrorDetail(error, 'Error al solicitar restablecimiento de contraseña'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-vh-100 d-flex align-items-center"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}
    >
      <Container>
        <div className="d-flex justify-content-center">
          <Card className="shadow-lg border-0" style={{ maxWidth: '500px', width: '100%' }}>
            <Card.Body className="p-4 p-md-5">
              <div className="text-center mb-4">
                <img 
                  src="/LOGO-DIRESA.png" 
                  alt="Logo DIRESA" 
                  className="mb-3"
                  style={{ maxHeight: '80px', width: 'auto' }}
                />
                <h2 className="fw-bold text-primary mb-2">Recuperar Contraseña</h2>
                <p className="text-muted">Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña</p>
              </div>

              {success && (
                <Alert variant="success" className="mb-4">
                  <Alert.Heading>¡Correo Enviado!</Alert.Heading>
                  <p>Si el correo existe en nuestro sistema, recibirás un enlace para restablecer tu contraseña. Por favor revisa tu bandeja de entrada.</p>
                </Alert>
              )}

              {error && (
                <Alert variant="danger" dismissible onClose={() => setError('')} className="mb-4">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  {error}
                </Alert>
              )}

              {!success && (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Correo Electrónico *</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="tu@email.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <Button 
                    variant="primary" 
                    type="submit" 
                    className="w-100 mb-3"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Enviando...
                      </>
                    ) : (
                      'Enviar Enlace de Recuperación'
                    )}
                  </Button>
                </Form>
              )}

              <div className="text-center">
                <Link to="/login" className="text-decoration-none">
                  Volver al Login
                </Link>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default ForgotPassword;

